import { Action } from "vuex-class";
import Component from "vue-class-component";
import Vue from "vue";

@Component
export default class WithLoginData extends Vue {
  @Action("login")
  public loginDataLogin!: (data: { email: string; password: string }) => Promise<void>;
}
